const mutations = {
  SET_STATE(state, importerState) {
    state.stateContainer['initial'] = null
    delete state.stateContainer['initial']
    state.stateContainer[importerState.state] = importerState.optionalData
  },
  RESET_STATE(state) {
    state.stateContainer = { initial: true }
  },
  UNSET_STATE(state, importerState) {
    state.stateContainer[importerState] = null
    delete state.stateContainer[importerState]
  },
}

export { mutations }
